import React, { useEffect, useState, useContext } from 'react'
import { apiPost } from '../../utils/apiFetch'
import apiPath from '../../utils/apiPath'
import { useForm } from 'react-hook-form'
import ErrorMessage from '../../components/ErrorMessage'
import useToastContext from 'hooks/useToastContext'
import { validateFile } from 'utils/reusableMethods'
import OImage from 'components/reusable/OImage'
import FormData from 'form-data'
import { useTranslation } from 'react-i18next'
import formValidation from '../../utils/formValidation'
import OInputField from 'components/reusable/OInputField'
import { preventMaxInput } from 'utils/validations'
import noImageFound from '../../assets/images/No-image-found.jpg'
import { useNavigate } from 'react-router-dom'
import AuthContext from 'context/AuthContext'
import helpers from 'utils/helpers'

const BannerAdd = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const notification = useToastContext()
  const { updatePageName } = useContext(AuthContext)
  const {
    register,
    handleSubmit,
    watch,
    formState: { errors }
  } = useForm({ mode: 'onChange', shouldFocusError: true, defaultValues: {} })

  const [addMerchantLoading, setAddMerchantLoading] = useState(false)
  const [bannerCardImg, setBannerCardImg] = useState({ img: null, url: null })
  const [fileMsg, setFileMsg] = useState({
    bannerImage: ''
  })
  const handleCheckError = () => {
    if (bannerCardImg?.img == null) {
      setFileMsg({
        ...fileMsg,
        bannerImage: 'Please upload the image.'
      })
    }
  }

  useEffect(() => {
    if (watch('bannerImage')?.length > 0) {
      setBannerCardImg({
        url: URL.createObjectURL(watch('bannerImage')[0]),
        img: watch('bannerImage')[0]
      })
      const banner_msg = validateFile(watch('bannerImage')[0])
      const fileSize = (watch('bannerImage')[0].size / (1024 * 1024)).toFixed(2)
      if (banner_msg) {
        setFileMsg({
          ...fileMsg,
          bannerImage: banner_msg
        })
      } else if (fileSize > 3) {
        setFileMsg({
          ...fileMsg,
          bannerImage: 'Please select image below 3Mb.'
        })
      } else {
        setFileMsg({
          ...fileMsg,
          bannerImage: ''
        })
      }
    }
  }, [watch('bannerImage')])

  const handleSubmitForm = async data => {
    try {
      if (fileMsg.bannerImage) {
        return
      }
      setAddMerchantLoading(true)
      const formData = new FormData()
      formData.append(
        'bannerImage',
        helpers.ternaryCondition(
          bannerCardImg?.img !== null,
          bannerCardImg?.img,
          data.bannerImage[0]
        )
      )
      formData.append('title', data.title?.trim())

      const res = await apiPost(apiPath.createBanner, formData)
      function successCallback () {
        navigate('/banner-management')
        notification.success(res.data.message)
      }
      function errorCallback () {
        notification.error(res?.data?.message)
      }
      helpers.handleResult(res.data.success, successCallback, errorCallback)
    } catch (err) {
      console.log('err:', err)
    } finally {
      setAddMerchantLoading(false)
    }
  }

  useEffect(() => {
    updatePageName(t('ADD_BANNER'))
  }, [])

  const renderButtonOrSpinner = () => {
    return helpers.ternaryCondition(
      addMerchantLoading,
      renderSpinner(),
      renderButton()
    )
  }

  const renderSpinner = () => (
    <div className='spinner-container bg-LightBlue text-white active:bg-emerald-600 font-normal text-sm px-8 py-2.5 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 ease-linear transition-all duration-150'>
      <div className='loading-spinner'></div>
    </div>
  )

  const renderButton = () => (
    <button
      className={`bg-LightBlue text-white active:bg-emerald-600 font-normal cursor-pointer text-sm px-8 py-2.5 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 ease-linear transition-all duration-150`}
      onClick={handleCheckError}
    >
      {t('O_ADD')}
    </button>
  )

  return (
    <>
      <div>
        <div className='bg-[#F9F9F9]'>
          <div className='px-3 py-4'>
            <div className='bg-white border border-[#E9EDF9] rounded-lg'>
              <form onSubmit={handleSubmit(handleSubmitForm)} method='post'>
                <div className='p-6 flex-auto relative'>
                  <div className='grid'>
                    <div className='px-2'>
                      <OInputField
                        wrapperClassName='relative z-0 w-full group'
                        type='text'
                        name='title'
                        autoFocus
                        maxLength={100}
                        inputLabel={
                          <>
                            {t('TITLE')}
                            <span className='text-red-500'>*</span>
                          </>
                        }
                        onInput={e => preventMaxInput(e, 100)}
                        register={register('title', formValidation['title'])}
                        errors={errors}
                      />
                    </div>
                    <div className='md:py-4 sm:px-2 sm:py-8 px-7'>
                      <div className='relative z-0   w-full group'>
                        <div className='block py-3 h-14 px-3 w-full text-sm text-gray-900 bg-transparent border-2 rounded-lg border-[#DFDFDF] appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0  peer'>
                          <input
                            type='file'
                            className='form-control'
                            accept='image/png,image/jpeg,image/jpg'
                            name='bannerImage'
                            {...register('bannerImage', {})}
                          />
                        </div>
                        <label
                          htmlFor='floating_file'
                          className='peer-focus:font-normal absolute text-sm text-[#A5A5A5] dark:text-gray-400 duration-300 transform -translate-y-6 scale-75 top-1 left-0 bg-white p-2 z-10 origin-[2] peer-focus:left-0 peer-focus:text-[#A5A5A5] peer-focus:text-lg peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-8'
                        >
                          {t('IMAGE')}
                          <span className='text-red-500'>*</span>
                        </label>
                        <ErrorMessage
                          message={helpers.ternaryCondition(
                            errors?.bannerImage?.message,
                            errors?.bannerImage?.message,
                            fileMsg.bannerImage
                          )}
                        />
                        <div className='flex items-center bg-white w-full h-[648px]'>
                          {bannerCardImg?.url && !fileMsg?.bannerImage && (
                            <OImage
                              src={
                                bannerCardImg?.url !== null
                                  ? bannerCardImg?.url
                                  : URL.createObjectURL(watch('bannerWatch')[0])
                              }
                              fallbackUrl={noImageFound}
                              className={'w-full h-full mt-5 object-cover'}
                            />
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className='flex items-center justify-center p-6 border-t border-solid border-slate-200 rounded-b'>
                  <button
                    className='text-black bg-[#E1E1E1] font-normal text-sm outline-none focus:outline-none px-12 py-2.5  rounded mr-6  ease-linear transition-all duration-150'
                    type='button'
                    onClick={() => navigate('/banner-management')}
                  >
                    {t('O_BACK')}
                  </button>
                  {renderButtonOrSpinner()}
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default BannerAdd
